import { c as _c } from "react/compiler-runtime";
import { FileSourceEnum } from '@systemeio/file-manager';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { getFilteredAttachmentsList } from 'modules/profile/mailing-settings/utils/file-utils';
import React from 'react';
import { SectionMessage } from 'shared/components';
import { useAttachmentsPolicy } from 'shared/components/dashboard-mail-editor/hooks/use-attachments-policy';
import { AttachmentFileInterface, UnsavedAttachmentFileInterface } from 'shared/components/dashboard-mail-editor/types/email-interface';
import { concatAttachments } from 'shared/components/dashboard-mail-editor/utils/concat-attachments';
import { FileUploaderWithListedFiles } from 'shared/components/file-uploader/file-uploader-with-listed-files';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { DashboardMailEditorCommonProps } from '../types/common';
export interface AttachmentsBlockProps extends Pick<DashboardMailEditorCommonProps, 'isPreFetching' | 'inModal' | 'disabled'> {
  attachmentsTempState: (AttachmentFileInterface | UnsavedAttachmentFileInterface)[];
  setAttachmentsTempState: React.Dispatch<React.SetStateAction<(AttachmentFileInterface | UnsavedAttachmentFileInterface)[]>>;
  mailingId?: MailingId;
  errors: string | undefined;
}
const AttachmentsBlock = t0 => {
  const $ = _c(21);
  const {
    isPreFetching,
    attachmentsTempState,
    setAttachmentsTempState,
    mailingId,
    errors
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data
  } = useAttachmentsPolicy(mailingId);
  let t1;
  if ($[0] !== data?.willBeSentAsLinks || $[1] !== t) {
    t1 = data?.willBeSentAsLinks && <SectionMessage variant="neutral">{t("dashboard.email.attachments_as_links")}</SectionMessage>;
    $[0] = data?.willBeSentAsLinks;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== attachmentsTempState) {
    t2 = attachmentsTempState.map(_temp);
    $[3] = attachmentsTempState;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== setAttachmentsTempState) {
    t3 = file => {
      setAttachmentsTempState(prev => concatAttachments(prev, file));
    };
    $[5] = setAttachmentsTempState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== attachmentsTempState || $[8] !== setAttachmentsTempState) {
    t4 = file_0 => {
      setAttachmentsTempState(getFilteredAttachmentsList(attachmentsTempState, file_0));
    };
    $[7] = attachmentsTempState;
    $[8] = setAttachmentsTempState;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isPreFetching || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <FileUploaderWithListedFiles source={FileSourceEnum.Email} files={t2} onSelect={t3} onDelete={t4} isPreFetching={isPreFetching} />;
    $[10] = isPreFetching;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== errors) {
    t6 = errors && <FieldErrorAndDescription error={errors} />;
    $[15] = errors;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t1 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex flex-col gap-5">{t1}{t5}{t6}</div>;
    $[17] = t1;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default AttachmentsBlock;
function _temp(item) {
  return {
    ...item.file,
    ...("id" in item ? {
      id: item.id
    } : {})
  };
}